import { LogInterface } from './LogInterface';

export default class Log implements LogInterface {
  private static instance: Log;

  /**
   * The Singleton's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  private constructor() {}

  /**
   * The static method that controls the access to the singleton instance.
   *
   * This implementation let you subclass the Singleton class while keeping
   * just one instance of each subclass around.
   */
  public static getInstance(): Log {
    if (!Log.instance) {
      Log.instance = new Log();
    }

    return Log.instance;
  }

  debug(message: string, ...otherData: any[]): void {
    //this.emitLogMessage("debug", message, otherData);
  }
  warn(message: string, ...otherData: any[]): void {
    this.emitLogMessage('warn', message, otherData);
  }
  error(message: string, ...otherData: any[]): void {
    this.emitLogMessage('error', message, otherData);
  }
  info(message: string, ...otherData: any[]): void {
    //this.emitLogMessage("info", message, otherData);
  }

  private emitLogMessage(
    msgType: 'debug' | 'info' | 'warn' | 'error',
    message: string,
    otherData: any[]
  ) {
    if (otherData.length > 0) {
      console[msgType](message, otherData);
    } else {
      console[msgType](message);
    }
  }
}
